import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RossService {
  private httpClient = inject(HttpClient);

  constructor() { }

  subscribeToMatch(_matchId: string, partner: string) {
    return this.httpClient.post<any>('api_endpoint' + '/partner/subscribe-to-match', { _matchId, partner })
  }

  subscribeToTie(tieId: string, partner: string) {
    return this.httpClient.post<any>('api_endpoint' + `/partner/subscribe-to-tie/${tieId}`, { partner })
  }

  subscribeToTournament(tournamentId: string, partner: string) {
    return this.httpClient.post<any>('api_endpoint' + `/partner/subscribe-to-tournament/${tournamentId}`, { partner });
  }

  unsubscribeFromTournament(tournamentId: string, partner: string) {
    return this.httpClient.post<any>('api_endpoint' + `/partner/unsubscribe-from-tournament/${tournamentId}`, { partner });
  }

  unsubscribeFromMatch(_matchId: string, partner: string) {
    return this.httpClient.post<any>('api_endpoint' + '/partner/unsubscribe-from-match', { _matchId, partner })
  }

  unsubscribeFromTie(tieId: string, partner: string) {
    return this.httpClient.post<any>('api_endpoint' + `/partner/unsubscribe-from-tie/${tieId}`, { partner })
  }

  getTieScoreSubscribers(tieId: string) {
    return this.httpClient.get<any>('api_endpoint' + `/tie/${tieId}/score-subscribers`)
  }

  getTournamentScoreSubscribers(tournamentId: string) {
    return this.httpClient.get<any>('api_endpoint' + `/tournament/${tournamentId}/score-subscribers`)
  }
}
